import React from 'react';
import { Modal } from 'react-bootstrap';
const _ = {
    find:       require('lodash/find'),
    map:        require('lodash/map'),
    some:       require('lodash/some'),
}

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');

const TUTORIAL_ACTIVITY_TYPES = Globals.short_course.TUTORIAL_ACTIVITY_TYPES;
const ASSESSMENT_ACTIVITY_TYPES = Globals.short_course.ASSESSMENT_ACTIVITY_TYPES;
const REMEDIAL_ACTIVITY_TYPES = Globals.short_course.REMEDIAL_ACTIVITY_TYPES;

import AccessibleIcon from '../common/AccessibleIcon';

function EditActivityDetailsModal(props) {
	let activity_type;
    if (props.courseLevel) {
        activity_type = (props.activity_type === null) ? 'NOT_REMEDIAL' : (props.activity_type || '');
    }
    else {
        activity_type = props.activity_type || '';
    }
    
    let any_rsd_ids = _.some(props.score_categories,(entry)=>(!!entry.rsd_id) );

    function getActivityTypeDisplayName(activity_type) {
        if (props.activityTypes) {
            const entry = _.find(props.activityTypes,{id: activity_type});
            if (entry) {
                return entry.name;
            }
        }
        return Globals.short_course.content_block_activity_types[activity_type] ||  activity_type;
    }
    
    
    return (
        <Modal
            className="short-course-activity-details-modal"
            show={true}
            keyboard
            autoFocus
            enforceFocus={false}
            restoreFocus={false}
            backdrop={false}
            animation={false}
            //container={mountNode}
            onHide={props.closeHandler}
            aria-labelledby={props.modalTitleId}
        >
            <Modal.Header
                closeButton
                closeLabel={Strings['en'].common.CLOSE}
                onHide={props.closeHandler}
            >
                <Modal.Title id={props.modalTitleId}>{props.modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <label>{'Gate:'}
                    <select value={activity_type} onChange={(e)=>{ props.onSetActivityType(e.target.value)} }>
						<option value={''} disabled>{'Select...'}</option>
                        {props.courseLevel ? null :
                         _.map(TUTORIAL_ACTIVITY_TYPES,(activity_type)=>(
                        <option key={activity_type} value={activity_type}>
                            {getActivityTypeDisplayName(activity_type)}
                        </option>
                        ))}
						{ _.map(REMEDIAL_ACTIVITY_TYPES,(activity_type)=>(
						<option key={activity_type} value={activity_type}>
                            {getActivityTypeDisplayName(activity_type)}
                        </option>
						))}
                        { props.courseLevel ? 
                        <option value={'NOT_REMEDIAL'}>{'Not remedial'}</option>
                        :
						 _.map(ASSESSMENT_ACTIVITY_TYPES,(activity_type)=>(
						<option key={activity_type} value={activity_type}>
                            {getActivityTypeDisplayName(activity_type)}
                        </option>
						))
                        }
                    </select>
                </label>
                
                <div className="right-side-buttons">
                    { (props.onSyncSubskills && any_rsd_ids) ? 
                    <button title="sync" className="sync-subskills-button" onClick={props.onSyncSubskills}>
                        Sync RSD ids<AccessibleIcon className="fa fa-refresh" label="sync rsd ids"/>
                    </button>
                    : null }
                </div>
                
                <table className="activity-subskill-table">
                    <thead>
                        <tr>
                            <th>{'Subskill'}</th>
                            <th>{'Objective Name'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.map(props.subskills,(ss,ss_index)=>{
                            let ssr = props.subskill_relations[ss.hash];
                            let objective_name = 'NONE';
                            if (ssr) {
                                if (ssr.cb_score_type === Globals.short_course.content_block_score_req_type.OVERALL) {
                                    objective_name = 'OVERALL'; // presumes there is not an objective with the name 'OVERALL'
                                }
                                else {
                                    if (_.find(props.score_categories,{name: ssr.objective_name})) {
                                        objective_name = ssr.objective_name;
                                    }
                                    else {
                                        ssr = null; // TODO is this required for anything?
                                    }
                                }
                            }
                            return (
                        <tr key={ss_index}>
                            <td>{ss.display_name}</td>
                            <td>
                                <select value={objective_name || ''} onChange={(e)=>{props.onSetSubskillValue(ss.hash, 'objective_name', e.target.value) }}>
                                    <option value={'OVERALL'}>{'Overall Score'}</option>
                                    {_.map(props.score_categories,(sc,i)=>(
                                    <option key={i} value={sc.name}>{sc.display_name}</option>
                                    ))}
                                    <option value={'NONE'}>{'none'}</option>
                                </select>
                            </td>
                        </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Modal.Body>

            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
} // EditActivityDetailsModal

export default EditActivityDetailsModal;